import { from, Observable, of, Subject } from "rxjs";
import { catchError, filter, mergeMap, tap } from "rxjs/operators";

export function executeOperation<V>(operation: () => Promise<V>, retryTimeout?: number) {
    return executeEffect(() => from(operation()), retryTimeout);
}

export function executeEffect<V>(effect: () => Observable<V>, retryTimeout = 1000) {
    const running$ = new Subject<boolean>();
    setTimeout(() => {
        running$.next(true);
    });
    const onError = (err: any) => {
        setTimeout(() => {
            running$.next(true);
        }, retryTimeout);
        running$.next(false);
        throw err;
    };
    return of({
        running$: from(running$),
        result$: running$.pipe(
            filter(x => x),
            mergeMap(() => effect()),
            catchError<V, V>(onError),
            tap(() => {
                running$.next(false);
                running$.complete();
            })
        ),
    });
}
